import type { ComponentProps } from 'react'
import { cn } from '@/lib/cn'
import { CloseIcon, SearchIcon } from './icons'

interface SearchFieldProps extends Omit<ComponentProps<'input'>, 'type' | 'size'> {
  onClear?: () => void
  size?: 'sm' | 'lg'
}

export function SearchField({ ref, className, onClear, size = 'lg', value, ...props }: SearchFieldProps) {
  const hasValue = typeof value === 'string' && value.length > 0
  return (
    <div className={cn('relative flex items-center', className)}>
      <SearchIcon size={size === 'lg' ? 20 : 17} className="pointer-events-none absolute left-4 text-fg-subtle" />
      <input
        ref={ref}
        type="search"
        value={value}
        autoComplete="off"
        spellCheck={false}
        className={cn(
          'w-full rounded-full bg-ink-850 text-fg ring-1 ring-line ring-inset placeholder:text-fg-subtle',
          'transition-[box-shadow,background-color] duration-200 hover:ring-line-strong',
          'focus:bg-ink-800 focus:ring-2 focus:ring-volt/70 focus:outline-none',
          '[&::-webkit-search-cancel-button]:appearance-none',
          size === 'lg' ? 'h-13 pr-12 pl-12 text-base' : 'h-9 pr-9 pl-10 text-sm',
        )}
        {...props}
      />
      {hasValue && onClear && (
        <button
          type="button"
          onClick={onClear}
          aria-label="Clear search"
          className="absolute right-2.5 grid size-8 place-items-center rounded-full text-fg-subtle hover:bg-white/[0.08] hover:text-fg"
        >
          <CloseIcon size={16} />
        </button>
      )}
    </div>
  )
}
